import PromptInput from './PromptInput';

export default PromptInput;
